






































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import layout from '@/layouts/app.vue';
import loading from '@/components/loading.vue';
import { User } from '@/shared/user';

const userStore = namespace('user');

@Component({
  components: {
    layout,
    loading,
  },
})
export default class UserProfileComponent extends Vue {
    public isLoading: boolean = false;

    @userStore.Getter
    public user!: User | null;

    public get fullName(): string {
        if (this.user == null) {
            return '';
        }

        let name = '';

        if (this.user.firstName != null && this.user.firstName.length > 0) {
            name += this.user.firstName.trim();
            name += ' ';
        }

        if (this.user.lastName != null && this.user.lastName.length > 0) {
            name += this.user.lastName.trim();
        }

        return name.trim();
    }
}
